let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jvmJs")).then(() => parcelRequire('kMgZf'));